/* eslint-disable react/prop-types */

import React  from 'react';

import { Spinner } from 'react-bootstrap';

import { observer } from 'mobx-react';

import jsBarcode from 'jsbarcode';

import { orderBarcode } from '../../store/OrderStore';

import "./labels.css";

// FIXME: Move into backend site database
const schoolNameMap = new Map([
    ['Ninja Kids, Brookvale, NSW', 'Ninja Kids, Brookvale'],
    ['Brookvale Public School Vacation Care, NSW', 'Brookvale Public Vacation'],
    ['Lane Cove West Public School, Lane Cove, NSW', 'Lane Cove West Public'],
    ['Ku-Ring-Gai Wildflower Garden, NSW', 'Ku-Ring-Gai Wildflower'],
    ['Turramurra Public School, NSW - OOSH', 'Turramurra Public OOSH'],
    ['Northside Montessori Vacation Care, NSW', 'Northside Montessori Vacation'],
    ['Northside Montessori School, Pymble, NSW', 'Northside Montessori'],
    ['Northside Montessori Pre-Primary, Pymble, NSW', 'Northside Montessori Pre-Primary'],
    ['Northside Montessori Highschool & Pre-Primary, Pymble, NSW', 'Northside Montessori HS & Pre-Primary'],
    ['Killara Public School, Killara, NSW', 'Killara Public'],
    ['Gordon East Public School, NSW', 'Gordon East Public'],
    ['St Ives Public School, St Ives, NSW', 'St Ives Public'],
    ['Turramurra North Public School, NSW', 'Turramurra North Public'],
    ['Inner Sydney Montessori School, Balmain, NSW', 'Inner Sydney Montessori'],
    ['Forestville Montessori School, Forestville, NSW', 'Forestville Montessori'],
    ['Tennyson Preschool, NSW - By Handprints', 'Tennyson Preschool'],
    ['Cowan Public School, NSW', 'Cowan Public School'],
    ['Brooklyn Public School, NSW', 'Brooklyn Public School'],
    ['Prouille Catholic Primary School, Wahroonga', 'Prouille Catholic School'],
]);

function Label({ order }) {
    const barcodeRef = React.useRef(null);
    const barcode = orderBarcode(order);

    React.useLayoutEffect(() => {
        if (!barcodeRef.current) return;
        jsBarcode(
            barcodeRef.current,
            barcode,
            {
                xmlDocument: window.document,
                height: 20,
                fontSize: 10,
                displayValue: false,
                margin: 6,
            }
        );
    }, []);

    const school = schoolNameMap.get(order.school) || order.school;

    const textLength
        = Math.floor(order.menuItem.length * 0.8)
        + school.length
        + order.customer.length
        + (order.allergies?.length || 0);

    const classSize
        // eslint-disable-next-line no-nested-ternary
        = textLength > 80
        ? (textLength > 100 ? ' very small' : ' small')
        : '';

    return <div className='label'>
        <div className={`order${classSize}`}>
            <p>
                <span className='school'>{school}</span>
                <span className='customer'>{order.customer}</span>
                <span className='orderType'>{order.orderType}</span>
            </p>
            <svg ref={barcodeRef} className='barcode'>
            </svg>
            <p>
                <span className='menuItem'>{order.menuItem}</span>
                {
                    order.allergies?.length > 0
                    ? <><br/><span className='allergies'>Allergies: {order.allergies}</span></>
                    : null
                }
                <span className={classSize}>{barcode}</span>
                <span className={`date${classSize}`}>{order.orderDate}</span>
            </p>
        </div>
    </div>;
}

const PrintLabels = observer(({ orderStore, subset }) => {
    if (orderStore.loading) {
        return <div style={{ textAlign: 'center', gridColumn: '1/-1', marginTop: '2em' }}>
            <span>Loading...<Spinner animation='border' variant='info' size='sm' style={{ marginLeft: '2rem'}}/></span>
        </div>
    }

    const orders = React.useMemo(() => {
        const subsetSet = subset ? new Set(subset) : null;

        const labels
            = subsetSet
            ? orderStore.orders.filter(e => subsetSet.has(e.id.toString()))
            : [...orderStore.orders];

        labels.sort((a, b) => {
            return a.menuItemBase.localeCompare(b.menuItemBase)
            || a.school.localeCompare(b.school)
            || a.orderType.localeCompare(b.orderType)
            || a.class.localeCompare(b.class);
        });

        return labels;
    }, [orderStore.orders, subset]);

    return (
        <div className='pageA4'>
            { orders.map(e => <Label key={e.id} order={e} />) }
        </div>
    );
});

export {
    PrintLabels,
}
